import React from 'react'

import { Box, SearchField } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface TableOptionsProps {
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const TableOptions = ({ search, onSearch }: TableOptionsProps) => {
  return (
    <Box width="full">
      <Box gap="s8" flexNoShrink flexDirection="row">
        <Box width="full">
          <SearchField
            variant="big"
            search={search}
            onSearch={onSearch}
            placeholder={i18n.t('common.search')}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default TableOptions
